import { Injectable } from '@angular/core';
import { LoadingDialogComponent } from '@components/loading-dialog/loading-dialog.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private ref!: DynamicDialogRef | undefined;

  constructor(private dialogService: DialogService) {}

  show() {
    if (this.ref === undefined)
      this.ref = this.dialogService.open(LoadingDialogComponent, {
        closable: false,
        draggable: false,
        styleClass: 'loading-overlay',
      });
  }

  hide() {
    if (this.ref !== undefined) {
      this.ref.close();
      /* for(let key of this.dialogService.dialogComponentRefMap.keys()){
        let element = this.dialogService.dialogComponentRefMap.get(key);
        element?.destroy();
      } */
      this.ref = undefined;
    }
  }
}
